import BigNumber from 'bignumber.js'

export function calculateTotalAndRemainingAmount (invoice) {
  const totalGrossAmount = calculateTotalGrossAmount(invoice)
  const totalPayments = calculatePayments(invoice.invoicePayments)

  const remaining = BigNumber(totalGrossAmount)
    .decimalPlaces(2)
    .minus(BigNumber(totalPayments).decimalPlaces(2))
    .toNumber()

  return {
    totalPayments,
    remaining
  }
}

export function calculateTotalGrossAmount (invoice) {
  const totalNetAmount = invoice.invoiceItems.reduce(
    (total, item) => total + item.netAmount,
    0
  )

  const taxAmount = (totalNetAmount * invoice.vat) / 100
  const totalGrossAmount = totalNetAmount + taxAmount

  return totalGrossAmount
}

export function calculatePayments (invoicePayments) {
  const totalPayments = invoicePayments.reduce(
    (total, payment) => total + (parseFloat(payment.amount) || 0),
    0
  )

  return totalPayments
}

export function isInvoiceOverpaid (invoice) {
  const { remaining } = calculateTotalAndRemainingAmount(invoice)

  if (invoice.isCreditNote) {
    return remaining > 0
  } else {
    return remaining < 0
  }
}
